// ----------------------------------------------------------------------

export const carouselClasses = {
  root: 'antl__carousel__root',
  container: 'antl__carousel__container',
  // dot
  dots: 'antl__carousel__dots',
  dot: 'antl__carousel__dot',
  // arrow
  arrows: 'antl__carousel__arrows',
  arrowsLabel: 'antl__carousel__arrows_label',
  arrowPrev: 'antl__carousel__btn--prev',
  arrowNext: 'antl__carousel__btn--next',
  arrowSvg: 'antl__carousel__btn__svg',
  // slide
  slide: 'antl__carousel__slide',
  slideContent: 'antl__carousel__slide__content',
  // thumb
  thumbs: 'antl__carousel__thumbs',
  thumb: 'antl__carousel__thumb',
  thumbContainer: 'antl__carousel__thumbs__container',
  thumbImage: 'antl__carousel__thumb__image',
  // progress
  progress: 'antl__carousel__progress',
  progressBar: 'antl__carousel__progress__bar',
  state: { selected: 'state--selected', disabled: 'state--disabled' },
};
